import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const TicketIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path d="M28.3988 13.06C28.8505 12.9681 29.2567 12.7229 29.5484 12.366C29.8402 12.009 29.9997 11.5623 30 11.1012V8C30 7.46957 29.7893 6.96086 29.4142 6.58579C29.0391 6.21071 28.5304 6 28 6H4C3.46957 6 2.96086 6.21071 2.58579 6.58579C2.21071 6.96086 2 7.46957 2 8V11.1012C2.00025 11.5623 2.15977 12.009 2.45156 12.366C2.74334 12.7229 3.14948 12.9681 3.60125 13.06C4.27676 13.2001 4.88334 13.5687 5.31882 14.1038C5.75431 14.6388 5.99208 15.3076 5.99208 15.9975C5.99208 16.6874 5.75431 17.3562 5.31882 17.8912C4.88334 18.4263 4.27676 18.7949 3.60125 18.935C3.14864 19.0271 2.74186 19.273 2.44997 19.631C2.15809 19.9889 1.9991 20.4369 2 20.8988V24C2 24.5304 2.21071 25.0391 2.58579 25.4142C2.96086 25.7893 3.46957 26 4 26H28C28.5304 26 29.0391 25.7893 29.4142 25.4142C29.7893 25.0391 30 24.5304 30 24V20.8988C29.9997 20.4377 29.8402 19.9909 29.5484 19.634C29.2567 19.2771 28.8505 19.0319 28.3988 18.94C27.7232 18.7999 27.1167 18.4313 26.6812 17.8962C26.2457 17.3612 26.0079 16.6924 26.0079 16.0025C26.0079 15.3126 26.2457 14.6438 26.6812 14.1088C27.1167 13.5737 27.7232 13.2051 28.3988 13.065V13.06ZM4 20.9C5.12962 20.6699 6.14501 20.0565 6.8743 19.1637C7.60358 18.2708 8.00194 17.1534 8.00194 16.0006C8.00194 14.8478 7.60358 13.7304 6.8743 12.8376C6.14501 11.9448 5.12962 11.3314 4 11.1012V8H11V24H4V20.9ZM28 20.9V24H13V8H28V11.1C26.8704 11.3301 25.855 11.9435 25.1257 12.8363C24.3964 13.7292 23.9981 14.8466 23.9981 15.9994C23.9981 17.1522 24.3964 18.2696 25.1257 19.1624C25.855 20.0552 26.8704 20.6686 28 20.8988V20.9Z" />
  </svg>
);

TicketIcon.propTypes = iconPropTypes;

export default TicketIcon;
